import * as z from 'zod';
import { getDefaults } from '../registry';
import type { Dictionary } from '../types';

export interface GetCellEditorIsDisabled {
  (row: Dictionary<any>): boolean;
}

export const BASE_CONFIG = z.object({
  lang: z
    .string()
    .optional()
    .default(() => getDefaults().lang),
});

export interface RendererComponent {
  component: any; // Vue Component
  minWidth?: number;
  width?: number;
  textAlign?: string;
  validators?: Dictionary<any>;
}

export interface CellRendererFactory {
  schema: z.ZodObject<any>;
  createComponent: (opts: any) => RendererComponent;
}

export interface ColumnRenderer {
  name: string;
  formatter: CellRendererFactory;
  editor?: CellRendererFactory;
  header?: string;
  headerIcon?: string;
  sortable?: boolean;
}
